exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cargo-title[data-v-a3b16006]{border-bottom:3px solid #eeeff2;padding-bottom:20px}.description-content[data-v-a3b16006]{background-color:#eeeff2;border-radius:20px}.top-p[data-v-a3b16006]{margin:0;color:#f05e61;font-weight:500}.top-h[data-v-a3b16006]{margin:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a3b16006","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Loads-transportation-for-companies.vue
// module id = 365
// module chunks = 0